import { Mic, Square } from "lucide-react";
import { motion } from "framer-motion";

export default function RecordButton({ isRecording, onToggle, disabled }) {
    return (
        <div className="relative inline-flex items-center justify-center" data-testid="record-button-wrap">
            {isRecording && (
                <>
                    <span className="absolute inset-0 rounded-full border-2 border-terracotta vf-pulse" />
                    <span className="absolute inset-0 rounded-full border-2 border-terracotta vf-pulse" style={{ animationDelay: "0.5s" }} />
                </>
            )}
            <motion.button
                type="button"
                onClick={onToggle}
                disabled={disabled}
                whileTap={{ scale: 0.92 }}
                whileHover={{ scale: 1.04 }}
                transition={{ type: "spring", stiffness: 400, damping: 22 }}
                className={`relative w-28 h-28 sm:w-32 sm:h-32 rounded-full flex items-center justify-center text-white shadow-[0_10px_40px_rgba(224,109,83,0.35)] disabled:opacity-50 disabled:cursor-not-allowed
                    ${isRecording ? "bg-terracotta/95" : "bg-terracotta hover:shadow-[0_14px_50px_rgba(224,109,83,0.45)]"}`}
                data-testid="record-button"
                aria-label={isRecording ? "Stop recording" : "Start recording"}
            >
                {isRecording ? <Square size={36} strokeWidth={1.5} fill="white" /> : <Mic size={42} strokeWidth={1.5} />}
            </motion.button>
        </div>
    );
}
